module.exports = __webpack_public_path__ + "img/fire-flame-10.dc91da46.png";